




















import { Component, Vue } from 'vue-property-decorator';
import Logo from '@/components/ui/Logo.vue';
import Sitemap from './Sitemap.vue';
import Services from './Services.vue';
import BottomBar from './BottomBar.vue';
import Contact from './Contact.vue';

@Component({
  components: {
    Logo,
    Sitemap,
    Services,
    Contact,
    BottomBar,
  },
})
export default class Footer extends Vue {}
